import { useEffect, useState } from 'react';
import { AUTH_SESSION_CHANGED_EVENT, readAuthSession } from 'utils/authSession';

/**
 * Reactive view of localStorage auth state (same source as route guards).
 */
export function useAuthSession() {
  const [session, setSession] = useState(() => readAuthSession());

  useEffect(() => {
    const sync = () => setSession(readAuthSession());

    sync();
    window.addEventListener(AUTH_SESSION_CHANGED_EVENT, sync);
    window.addEventListener('storage', sync);

    return () => {
      window.removeEventListener(AUTH_SESSION_CHANGED_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  return session;
}
